function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("rect", {
  id: "avatar-5-a",
  width: 70,
  height: 70,
  rx: 24
}), React.createElement("linearGradient", {
  id: "avatar-5-c",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#E6864E"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#EB965E"
})), React.createElement("linearGradient", {
  id: "avatar-5-e",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#FECBB5"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#FED4C4"
})), React.createElement("path", {
  id: "avatar-5-d",
  d: "M41.783 7.35C42.802 9.607 43.574 14.157 44.1 21H0C.526 14.157 1.298 9.607 2.317 7.35 3.657 4.384 12.48.979 15.067 0c1.493 1.665 4.332 2.73 7.333 2.73 3 0 5.14-1.065 6.634-2.73 2.586.979 11.41 4.384 12.749 7.35z"
}));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("mask", {
  id: "avatar-5-b",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#avatar-5-a"
})), React.createElement("use", {
  fill: "#A0A6B8",
  opacity: 0.1,
  xlinkHref: "#avatar-5-a"
}), React.createElement("g", {
  mask: "url(#avatar-5-b)"
}, React.createElement("path", {
  d: "M3.5 7h63v63h-63z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M47.378 32.885c15.165-12.357.85-23.656-14.528-17.635-1.645.644-6.203-1.934-10.426.783-2.724 1.752-1.663 3.125-2.724 4.498-1.06 1.373-5.15 1.292-6.045 4.858-.53 2.112.938 4.324.742 5.914-.196 1.59-1.745 3.023-1.82 5.121-.13 3.731 2.8 6.86 6.547 6.99a6.81 6.81 0 0 0 6.574 6.76c1.17.04 4.134.04 6.681-1.488 6.381-3.829 4.949-7.612 14.999-15.8z"
}), React.createElement("path", {
  fill: "url(#avatar-5-c)",
  d: "M19.391 34.78c0-1.9-.066-11.272-.062-11.43-5.32.768-5.212-9.155.17-6.727 1.184.739 4.52 0 4.198-6.123 5.812 6.123 12.56-1.018 13.14 4.8.79 7.947-.005 16.263-5.04 16.263a9.615 9.615 0 0 1-1.642-.16v3.378c0 1.407 1.292 2.463 3.875 3.167-4.462 4.123-7.62 6.174-9.472 6.152-1.853-.022-4.867-2.073-9.042-6.152 2.584-.704 3.875-1.76 3.875-3.167z",
  transform: "translate(11.9 11.9)"
}), React.createElement("path", {
  fill: "#DB6F3D",
  fillRule: "nonzero",
  d: "M41.966 43.297c-2.876-.62-5.326-1.682-7.35-3.187 1.221 2.969 3.67 4.734 7.343 5.297l.007-2.11z"
}), React.createElement("g", {
  transform: "translate(14.7 49)"
}, React.createElement("mask", {
  id: "avatar-5-f",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#avatar-5-d"
})), React.createElement("use", {
  fill: "url(#avatar-5-e)",
  fillRule: "nonzero",
  xlinkHref: "#avatar-5-d"
}), React.createElement("path", {
  fill: "#FFA789",
  fillRule: "nonzero",
  d: "M5.546 7.56A1.262 1.262 0 0 1 4.282 6.3c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0A1.262 1.262 0 0 1 37.99 6.3c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zM1.332 3.36A1.262 1.262 0 0 1 .068 2.1c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0A1.262 1.262 0 0 1 8.495 2.1c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm25.282 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zM5.546 15.96a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm-37.922-4.2A1.262 1.262 0 0 1 .068 10.5c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.699 0 1.264.564 1.264 1.26 0 .696-.565 1.26-1.264 1.26zm8.428 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.565-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm-42.136 8.4A1.262 1.262 0 0 1 .068 18.9c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.699 0 1.264.564 1.264 1.26 0 .696-.565 1.26-1.264 1.26zm8.428 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.565-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26zm8.427 0a1.262 1.262 0 0 1-1.264-1.26c0-.696.566-1.26 1.264-1.26.698 0 1.264.564 1.264 1.26 0 .696-.566 1.26-1.264 1.26z",
  mask: "url(#avatar-5-f)"
}))));

var SvgAvatar6 = function SvgAvatar6(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgAvatar6, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/avatar-6.e66f29ed.svg";
export { ForwardRef as ReactComponent };